import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { createQueryFn, drawQueryKeys } from '../../../../lib/entry.js';
import { useSuspenseQuery } from '../../../../tanstack/entry.js';
import { getDraw } from '../../../actions/draw/getDraw.js';
import { useEngine } from '../../engine/entry.js';
const fetcher = createQueryFn(getDraw);
/**
 * Gets given draw. Will seed the draw from opened draws.
 *
 * @param drawQueryOptions Draw number to get draw for
 * @param queryOptions Fetch query options
 * @returns Draw model
 */
export function useDraw(drawQueryOptions, queryOptions) {
  const $ = _c(15);
  const queryClient = useQueryClient();
  const definition = useEngine();
  let t0;
  if ($[0] !== drawQueryOptions.drawNumber || $[1] !== drawQueryOptions.product) {
    t0 = drawQueryKeys.draw(drawQueryOptions.product, drawQueryOptions.drawNumber);
    $[0] = drawQueryOptions.drawNumber;
    $[1] = drawQueryOptions.product;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = queryOptions?.defaultValue;
  let t2;
  if ($[3] !== t1) {
    t2 = fetcher({
      defaultValue: t1
    });
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== definition || $[6] !== drawQueryOptions.drawNumber || $[7] !== drawQueryOptions.product || $[8] !== queryClient) {
    t3 = () => queryClient.getQueryData(drawQueryKeys.openedDraws(definition.moduleEngine))?.find(drawData => drawData.draw.drawNumber === drawQueryOptions.drawNumber && drawData.draw.product === drawQueryOptions.product);
    $[5] = definition;
    $[6] = drawQueryOptions.drawNumber;
    $[7] = drawQueryOptions.product;
    $[8] = queryClient;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== queryOptions || $[11] !== t0 || $[12] !== t2 || $[13] !== t3) {
    t4 = {
      ...queryOptions,
      queryKey: t0,
      queryFn: t2,
      initialData: t3
    };
    $[10] = queryOptions;
    $[11] = t0;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return useSuspenseQuery(t4);
}